import FieldKit from 'field-kit';
import TextField from './TextField';

export default class PhoneField extends TextField {
  getFormatter() {
    return new FieldKit.PhoneFormatter();
  }
}

PhoneField.propTypes = TextField.getBasePropTypes();

PhoneField.defaultProps = TextField.getBaseDefaultProps();




/** WEBPACK FOOTER **
 ** ./src/components/FieldKit/PhoneField.jsx
 **/